import { Factory } from 'miragejs';
import faker from 'faker';

export default {
  athlete: Factory.extend({
    firstName: (i) => `${i} ${faker.name.firstName()}`,
    lastName: () => faker.name.lastName(),
    image: (i) => `https://picsum.photos/600/400?random=${i}`,
  }),
};
